(function () {
  'use strict';

  // Shared by every accordion group in the Single Product template (Product
  // Hero buy-box accordion, FAQ accordion). Groups are independent of each
  // other — opening an item in one group never affects another group on the
  // same page. Binding is guarded per-button so this file can safely be
  // included by more than one section on the same page without attaching
  // duplicate click listeners.
  function initAccordionGroup(group) {
    var buttons = group.querySelectorAll(':scope > .accordion-item > .accordion-header');

    buttons.forEach(function (btn) {
      if (btn.dataset.accordionBound === 'true') return;
      btn.dataset.accordionBound = 'true';

      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';

        buttons.forEach(function (otherBtn) {
          if (otherBtn === btn) return;
          var otherPanel = document.getElementById(otherBtn.getAttribute('aria-controls'));
          otherBtn.setAttribute('aria-expanded', 'false');
          if (otherPanel) {
            otherPanel.setAttribute('aria-hidden', 'true');
            otherPanel.style.maxHeight = '';
          }
        });

        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
        panel.style.maxHeight = isOpen ? '' : panel.scrollHeight + 'px';
      });
    });

    // Give whichever item defaults to expanded (e.g. "Benefits", or the
    // first FAQ question) a real max-height on load — otherwise it renders
    // visually collapsed until the shopper interacts with it.
    group.querySelectorAll(':scope > .accordion-item > .accordion-panel[aria-hidden="false"]').forEach(function (panel) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    });
  }

  document.querySelectorAll('[data-accordion-group]').forEach(initAccordionGroup);
})();
